export const formatGeofenceName = (geofenceName: string): string => {
  const parsedGeofenceName = Number(geofenceName);
  if (!isNaN(parsedGeofenceName)) {
    return `Geofence ${geofenceName}`;
  }
  return geofenceName;
};

export const sortGeofences = (
  geofenceA: string,
  geofenceB: string,
  multiplier: number = 1
): number => {
  if (geofenceA === geofenceB) {
    return 0;
  }

  if (!geofenceA) {
    return 1;
  }

  if (!geofenceB) {
    return -1;
  }

  // Check if both geofences are purely numeric
  const parsedA = Number(geofenceA);
  const parsedB = Number(geofenceB);

  if (!isNaN(parsedA) && !isNaN(parsedB)) {
    return (parsedA > parsedB ? 1 : -1) * multiplier;
  }

  if (!isNaN(parsedA) && isNaN(parsedB)) {
    return -multiplier;
  }

  if (isNaN(parsedA) && !isNaN(parsedB)) {
    return multiplier;
  }

  const parseNumericSuffix = (geofence: string): number | null => {
    const parts = geofence.split(' ');
    const lastPart = parts[parts.length - 1];
    const parsed = Number(lastPart);
    return isNaN(parsed) ? null : parsed;
  };

  // Check for numeric suffixes
  const numericSuffixA = parseNumericSuffix(geofenceA);
  const numericSuffixB = parseNumericSuffix(geofenceB);

  if (numericSuffixA !== null && numericSuffixB !== null) {
    return (numericSuffixA > numericSuffixB ? 1 : -1) * multiplier;
  }

  // Fallback to string comparison
  return geofenceA.toLowerCase().localeCompare(geofenceB.toLowerCase()) * multiplier;
};
